import React, { useEffect, useContext } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from '@material-ui/core/styles';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker, } from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';
import useFetch from 'CustomHooks/useFetch';
import OrderHistoryLine from './OrderHistoryLine';
import { formatDate, getFormattedDateTime } from '../../../Util/DateFunctions';
import { GlobalContext } from '../../../Contexts/GlobalContext';
import useGuiTranslations from '../../../Components/MultiLanguage/useGuiTranslations';
import trLocale from "date-fns/locale/tr";


function OrderHistory() {
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [getOrdersResponse, getOrdersHook] = useFetch();
  const globalContext = useContext(GlobalContext);
  const [translateGui] = useGuiTranslations();

  const handleDateChange = date => {
    console.log(formatDate(date));
    setSelectedDate(date);
    getOrders(date);
  };

  const theme = useTheme();
  const useStyles = makeStyles({
    card: {

      overflowX: 'hidden',

      '@media (min-width : 600px)': {
        // width: 'calc(100% - 20px)',
      },
      '& td': {
        //borderBottom : 'none',
        //padding:'0px 24px 0px 16px',
        fontSize: '12px',
      },
      '& th': {
        //padding: '16px 16px 0px 16px',
      },
      '& tbody>tr:not(:last-child):nth-child(2n-1)': {
        //backgroundColor : '#604a0814',  
        //backgroundColor : 'rgb(247, 247, 247)',

      }
    },

  });

  const getOrders = (queryDate) => {
    let orderDate = queryDate == null ? (formatDate(new Date())) : formatDate(queryDate);
    getOrdersHook(
      {
        url: `/admin/orders?PaymentStatus=Completed&DateStart=${orderDate}&DateEnd=${orderDate}`,
        addTokenHeader: true,
        method: 'GET',
        postData: null,
      }
    );
  }

  useEffect(
    () => {
      //window.gtag('config', 'UA-160225157-2', {'page_path': '/OrderHistory'});
    }, []
  )

  useEffect(
    () => {
      getOrders();

      globalContext.dispatchMethod(
        {
          type: 'SET_MENU_LOCATION',
          value: { 
            a: 1,
            b: 3,
          },
        }
      )

    }, []
  )


  return (
    <div>
      <TableContainer component={Paper} elevation={5} className={useStyles().card}>
        <div className="table-header-1">
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={globalContext.globalState.selectedGuiLanguage == 'tr' ? trLocale : null}>
            <Grid container justify="flex-start" style={{ marginLeft: '10px' }}>
              <KeyboardDatePicker
                
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label={translateGui(30)}
                value={selectedDate}
                onChange={handleDateChange}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </Grid>
          </MuiPickersUtilsProvider>
        </div>
        <div className="table-header-2">
          <Typography variant="body2" display="block" >

          </Typography>

        </div>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>

              <TableCell className="ilk-harf-buyuk" align="left">{translateGui(25)}</TableCell>
              <TableCell className="ilk-harf-buyuk" align="left">{translateGui(31)}</TableCell>
              <TableCell className="ilk-harf-buyuk" align="left">{translateGui(32)}</TableCell>
              <TableCell className="ilk-harf-buyuk" align="right">{translateGui(29)}</TableCell>
              <TableCell align="right"></TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {
              getOrdersResponse.orderList != undefined ?
                getOrdersResponse.orderList.map(
                  order =>
                    <OrderHistoryLine order={order}></OrderHistoryLine>
                )

                : null
            }
          </TableBody>
        </Table>
      </TableContainer>


    </div>
  );
}

export default OrderHistory;
